import { axiosInstance } from '@/shared/api/axios';
import {
  AiCreditReportListRequestType,
  AiCreditReportListResponseType,
} from '@/shared/types/api/api.aiCredit';

export const getAiCreditReportList = async ({
  groupId,
  customerId,
  pageIndex,
  pageSize,
}: AiCreditReportListRequestType): Promise<AiCreditReportListResponseType> => {
  const { data } = await axiosInstance.get<AiCreditReportListResponseType>(
    `/group/${groupId}/customer/${customerId}/ai-credit-reports`,
    {
      params: {
        limit: pageSize,
        offset: (pageIndex - 1) * pageSize,
      },
      suppressErrorDialog: true,
    },
  );
  return data;
};
